import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import CategorySection from './components/CategorySection';
import ContentSection from './components/ContentSection';
import TutorialSection from './components/TutorialSection';
import FAQSection from './components/FAQSection';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';

const homeSEO = {
  title: '蜜桃视频主页 - 官方入口与全功能导航指南 | 蜜桃视频官网',
  description: '蜜桃视频主页是用户访问蜜桃视频平台的核心入口，本页为您详细介绍蜜桃视频主页的功能布局、登录注册流程、内容分类导航及常见问题解答，帮助您快速找到并顺利使用蜜桃视频主页的全部功能。',
  keywords: '蜜桃视频主页,蜜桃视频主页入口,蜜桃视频主页官网,蜜桃视频主页登录,蜜桃视频主页功能介绍,蜜桃视频主页内容分类,蜜桃视频主页使用教程',
  canonicalUrl: 'https://www.mitaovideo.com/',
  jsonLd: [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '蜜桃视频',
      url: 'https://www.mitaovideo.com',
      description: '蜜桃视频是一个高品质在线视频内容平台，汇聚海量优质视频资源。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.mitaovideo.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '蜜桃视频',
      url: 'https://www.mitaovideo.com',
      description: '蜜桃视频是一个高品质在线视频内容平台，致力于为用户提供流畅、高清的视频观看体验。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-6666',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        { '@type': 'Question', name: '蜜桃视频主页怎么进入？入口在哪里？', acceptedAnswer: { '@type': 'Answer', text: '您可以直接在浏览器中输入蜜桃视频主页官网地址访问，也可以通过搜索引擎搜索"蜜桃视频主页"找到入口。' } },
        { '@type': 'Question', name: '蜜桃视频需要付费吗？', acceptedAnswer: { '@type': 'Answer', text: '蜜桃视频提供免费和付费两种观看模式。免费用户可以观看大部分内容，付费会员可享受更多权益。' } },
        { '@type': 'Question', name: '蜜桃视频主页有哪些功能？', acceptedAnswer: { '@type': 'Answer', text: '蜜桃视频主页提供八大内容分类导航、智能推荐、高清视频播放、弹幕互动等功能。' } },
        { '@type': 'Question', name: '如何在蜜桃视频主页注册账号？', acceptedAnswer: { '@type': 'Answer', text: '点击蜜桃视频主页右上角的"注册"按钮，输入手机号获取验证码，设置密码后即可完成注册。' } },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead {...homeSEO} />
      <ScrollToTop />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <FeatureSection />
          <CategorySection />
          <ContentSection />
          <TutorialSection />
          <FAQSection />
        </article>
      </main>
      <Footer />
    </>
  );
}